import { StylesConfig } from "react-select";

import { PRIMARY_COLORS } from "const";
import { ISelectOption } from "types";
import { queryClient } from "../index";
import { supabase } from "lib/supabaseClient";

const defaultTheme = {
  fontSize: {
    xs: "0.75rem",
    sm: "0.875rem",
  },
  colors: {
    gray: {
      200: "#e5e7eb",
    },
  },
};

export function getStylesForReactSelectInputs(
  config: StylesConfig<ISelectOption> = {}
) {
  const customStyles: StylesConfig<ISelectOption> = {
    valueContainer: (provided) => ({ ...provided, flexWrap: "nowrap" }),
    dropdownIndicator: (provided) => {
      return {
        ...provided,
        padding: 0,
        color: "black",
        fontSize: defaultTheme.fontSize.xs,
        width: "15px",
      };
    },
    indicatorSeparator: () => ({}),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontSize: defaultTheme.fontSize.sm,
      textWrap: "nowrap",
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: PRIMARY_COLORS.GHOST_WHITE,
      borderColor: defaultTheme.colors.gray[200],
      height: "40px",
    }),
    option: () => ({ display: "flex", alignItems: "center" }),
    menuList: (provided) => ({
      ...provided,
      paddingTop: "8px",
      paddingBottom: "12px",
      paddingLeft: "24px",
      paddingRight: "24px",
    }),
    ...config,
  };
  return customStyles;
}

export async function logout() {
  await supabase.auth.signOut();
  queryClient.removeQueries();
  window.location.reload();
}
